module.exports = __webpack_public_path__ + "img/Hepatology202206.b0114329.jpg";